/* eslint-disable */
import MonthList from './MonthList';

export default MonthList;
